module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login-body"
  }, [(_vm.shibLogin == false) ? _c('div', {
    staticClass: "login-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-panel-body"
  }, [_c('h2', [_vm._v("Bejelentkezés")]), _vm._v(" "), _c('form', [_c('inputbox', {
    attrs: {
      "id": "username",
      "label": "Felhasználónév",
      "keydownEnter": _vm.login,
      "errors": _vm.errors,
      "name": "username"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  }), _vm._v(" "), _c('passwordbox', {
    attrs: {
      "id": "password",
      "label": "Jelszó",
      "keydownEnter": _vm.login,
      "errors": _vm.errors,
      "name": "password"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions clearfix"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Bejelentkezés")]), _vm._v(" "), (_vm.shibLogin == false) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.switchLogin
    }
  }, [_vm._v("Bejelentkezés címtárral")]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.shibLogin == true) ? _c('section', {
    staticClass: "shib_login-panel"
  }, [_c('div', {
    staticClass: "shib_load"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right shibback",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.switchLogin
    }
  }, [_vm._v("Címtár nélküli bejelentkezés")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "frameborder": "0",
      "src": _vm.shibLoginUrl,
      "width": "800px",
      "height": "655px"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-panel-head"
  }, [_c('h1', [_c('i', {
    staticClass: "kricon fa fa-id-card-o"
  }), _c('h1', [_vm._v("KMR"), _c('span', [_vm._v(" - Kártya menedzsment rendszer")])])]), _vm._v(" "), _c('p', [_vm._v("A Széchenyi István Egyetem kártya menedzsment felülete.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6ac6bb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/login.vue
// module id = 59
// module chunks = 0